import loadGoogleMapsApi from 'load-google-maps-api';

export default class SimpleGoogleMap {

  constructor() {
    this.googleMap;
    this.mapContainer = document.getElementById('simple-map');
    this.latitude;
    this.longitude;
    this.zoom
  }

  initGoogleMap() {
    if (this.mapContainer) {
      this.zoom = parseInt(this.mapContainer.getAttribute('data-zoom'));
      this.latitude = parseFloat(this.mapContainer.getAttribute('data-latitude'));
      this.longitude = parseFloat(this.mapContainer.getAttribute('data-longitude'));
      const app = this;

      loadGoogleMapsApi({key: 'AIzaSyB7mch4b3-jZ3vwrCUeNtJ4VfKxoYqe0oc'}).then(function (googleMaps) {
        app.googleMap = new googleMaps.Map(app.mapContainer, {
          center: { lat: app.latitude, lng: app.longitude },
          zoom: app.zoom,
          zoomControl: false,
          mapTypeControl: true,
          scaleControl: false,
          streetViewControl: true,
          rotateControl: false,
          fullscreenControl: false
        });

        app.addMarker();
      }).catch(function (error) {
        console.error(error)
      });
    }
  }

  addMarker() {
    const app = this;
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng({ lat: app.latitude, lng: app.longitude }),
      map: app.googleMap,
      optimized: false
    });
  }

}



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/SimpleGoogleMap.jsx